import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInpost = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 16,
		fill: "#FFCB04"
	}), /* @__PURE__ */ _jsx("g", {
		transform: "translate(7 7) scale(0.241348) translate(13.440 1.162)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "InPost-www",
			stroke: "none",
			strokeWidth: 1,
			fill: "#424143",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "strona-glowna",
				transform: "translate(-154.000000, -11.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "header",
					children: /* @__PURE__ */ _jsx("g", {
						id: "logo",
						transform: "translate(154.000000, 11.000000)",
						children: /* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", {
								d: "M17.332778,36.1712445 C17.332778,36.1712445 13.4532357,37.6608809 8.66641648,37.6608809 C3.88014645,37.6608809 5.49199062e-05,36.1712445 5.49199062e-05,36.1712445 C5.49199062e-05,36.1712445 3.88014645,34.681881 8.66641648,34.681881 C13.4532357,34.681881 17.332778,36.1712445 17.332778,36.1712445",
								id: "Fill-27",
								fill: "#424143"
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group-31",
								transform: "translate(19.496568, 0.258000)",
								children: [/* @__PURE__ */ _jsx("g", { id: "Clip-30" }), /* @__PURE__ */ _jsx("path", {
									d: "M9.81962498,14.0057182 C9.81962498,14.0057182 6.38191321,11.7063546 3.7051168,7.84290002 C1.02914418,3.97944546 0.127359263,0.0145363631 0.127359263,0.0145363631 C0.127359263,0.0145363631 3.56479643,2.3139 6.24186744,6.17708183 C8.91811466,10.0410818 9.81962498,14.0057182 9.81962498,14.0057182",
									id: "Fill-29",
									fill: "#424143"
								})]
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M20.5391943,23.7168825 C20.5391943,23.7168825 16.3954873,23.2584279 12.1694005,21.0700643 C7.9433136,18.8825188 5.23576217,15.7938824 5.23576217,15.7938824 C5.23576217,15.7938824 9.37946917,16.2523369 13.605556,18.4404279 C17.8316429,20.6282461 20.5391943,23.7168825 20.5391943,23.7168825",
								id: "Fill-32",
								fill: "#424143"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M28.901355,43.3436735 C31.3612177,43.3204916 34.3279912,41.3966734 34.3279912,41.3966734 C34.3279912,41.3966734 27.4487234,39.3288552 27.8817668,33.2006733 C29.2382886,23.1433094 37.4370072,15.2473093 47.7007144,13.9766729 C46.6122018,13.8274911 45.5006228,13.7494911 44.3687235,13.7541819 C31.6739866,13.8100365 21.4286775,23.8769458 21.4855566,36.2383097 C21.5426364,48.5991281 31.88076,58.5746738 44.5757716,58.519269 C45.6346274,58.5146738 46.6745359,58.4342192 47.6946732,58.2945828 C38.6867097,57.1766737 31.3549019,50.99231 28.7247875,42.8192189",
								id: "Fill-34",
								fill: "#424143"
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group-38",
								transform: "translate(19.496568, 57.803455)",
								children: [/* @__PURE__ */ _jsx("g", { id: "Clip-37" }), /* @__PURE__ */ _jsx("path", {
									d: "M9.81962498,0.189981826 C9.81962498,0.189981826 6.38191321,2.48961821 3.7051168,6.35361823 C1.02914418,10.2165274 0.127359263,14.1819819 0.127359263,14.1819819 C0.127359263,14.1819819 3.56479643,11.8823455 6.24186744,8.01889097 C8.91811466,4.1554364 9.81962498,0.189981826 9.81962498,0.189981826",
									id: "Fill-36",
									fill: "#424143"
								})]
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M20.5391943,48.5409279 C20.5391943,48.5409279 16.3954873,48.9993825 12.1694005,51.1877462 C7.9433136,53.375019 5.23576217,56.4636555 5.23576217,56.4636555 C5.23576217,56.4636555 9.37946917,56.0052009 13.605556,53.8173826 C17.8316429,51.6292916 20.5391943,48.5409279 20.5391943,48.5409279",
								id: "Fill-39",
								fill: "#424143"
							}),
							/* @__PURE__ */ _jsx("g", { id: "Clip-42" })
						] })
					})
				})
			})
		})
	})]
});
export default SvgInpost;
